"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapWarningStateToText = void 0;
const mapWarningStateToText = (warning, full) => {
    let text = "";
    switch (warning.reason) {
        case "COURSE":
            text += "Course may not be in optimal condition following maintenance";
            break;
        case "GREENS":
            text += "Greens may not be in optimal condition following maintenance";
            break;
        case "FAIRWAYS":
            text += "Fairways may not be in optimal condition following maintenance";
            break;
        case "BUNKERS":
            text += "Bunkers may not be in optimal condition following maintenance";
            break;
        case "CUSTOM":
            text += warning.reason_custom;
            break;
    }
    if (!full)
        return text;
    return `${text}`;
};
exports.mapWarningStateToText = mapWarningStateToText;
